// @core/api/endpoints/chat/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AddConversationMember } from './add_conversation_member';
import { AddReaction } from './add_reaction';
import { ArchiveConversation } from './archive_conversation';
import { CreateChatPolicy } from './create_chat_policy';
import { CreateConversation } from './create_conversation';
import { CreateMentionTag } from './create_mention_tag';
import { DeleteChatPolicy } from './delete_chat_policy';
import { DeleteConversation } from './delete_conversation';
import { DeleteMentionTag } from './delete_mention_tag';
import { DeleteMessage } from './delete_message';
import { EditMessage } from './edit_message';
import { ForwardMessages } from './forward_messages';
import { GetChatPolicy } from './get_chat_policy';
import { GetChatPolicyByEntity } from './get_chat_policy_by_entity';
import { GetConversation } from './get_conversation';
import { GetConversationSummary } from './get_conversation_summary';
import { GetMessage } from './get_message';
import { GetOrCreateDirectConversation } from './get_or_create_direct_conversation';
import { GetPresence } from './get_presence';
import { GetUnreadCounts } from './get_unread_counts';
import { LeaveConversation } from './leave_conversation';
import { ListChatPolicies } from './list_chat_policies';
import { ListConversationMembers } from './list_conversation_members';
import { ListConversations } from './list_conversations';
import { ListMentionTags } from './list_mention_tags';
import { ListMessageReaders } from './list_message_readers';
import { ListMessages } from './list_messages';
import { ListMyMentionTagSubscriptions } from './list_my_mention_tag_subscriptions';
import { ListPinnedMessages } from './list_pinned_messages';
import { ListThreadReplies } from './list_thread_replies';
import { MarkAsRead } from './mark_as_read';
import { PinMessage } from './pin_message';
import { RemoveConversationMember } from './remove_conversation_member';
import { RemoveReaction } from './remove_reaction';
import { ReplyInThread } from './reply_in_thread';
import { ResolveChatContext } from './resolve_chat_context';
import { SearchMessages } from './search_messages';
import { SendMessage } from './send_message';
import { SendTypingIndicator } from './send_typing_indicator';
import { SubscribeToMentionTag } from './subscribe_to_mention_tag';
import { UnpinMessage } from './unpin_message';
import { UnsubscribeFromMentionTag } from './unsubscribe_from_mention_tag';
import { UpdateChatPolicy } from './update_chat_policy';
import { UpdateConversation } from './update_conversation';
import { UpdateConversationMemberRole } from './update_conversation_member_role';
import { UpdatePresence } from './update_presence';

// Re-export individual endpoints
export {
  AddConversationMember,
  AddReaction,
  ArchiveConversation,
  CreateChatPolicy,
  CreateConversation,
  CreateMentionTag,
  DeleteChatPolicy,
  DeleteConversation,
  DeleteMentionTag,
  DeleteMessage,
  EditMessage,
  ForwardMessages,
  GetChatPolicy,
  GetChatPolicyByEntity,
  GetConversation,
  GetConversationSummary,
  GetMessage,
  GetOrCreateDirectConversation,
  GetPresence,
  GetUnreadCounts,
  LeaveConversation,
  ListChatPolicies,
  ListConversationMembers,
  ListConversations,
  ListMentionTags,
  ListMessageReaders,
  ListMessages,
  ListMyMentionTagSubscriptions,
  ListPinnedMessages,
  ListThreadReplies,
  MarkAsRead,
  PinMessage,
  RemoveConversationMember,
  RemoveReaction,
  ReplyInThread,
  ResolveChatContext,
  SearchMessages,
  SendMessage,
  SendTypingIndicator,
  SubscribeToMentionTag,
  UnpinMessage,
  UnsubscribeFromMentionTag,
  UpdateChatPolicy,
  UpdateConversation,
  UpdateConversationMemberRole,
  UpdatePresence,
};

// Namespace export for convenient usage
export const chatApi = {
  AddConversationMember,
  AddReaction,
  ArchiveConversation,
  CreateChatPolicy,
  CreateConversation,
  CreateMentionTag,
  DeleteChatPolicy,
  DeleteConversation,
  DeleteMentionTag,
  DeleteMessage,
  EditMessage,
  ForwardMessages,
  GetChatPolicy,
  GetChatPolicyByEntity,
  GetConversation,
  GetConversationSummary,
  GetMessage,
  GetOrCreateDirectConversation,
  GetPresence,
  GetUnreadCounts,
  LeaveConversation,
  ListChatPolicies,
  ListConversationMembers,
  ListConversations,
  ListMentionTags,
  ListMessageReaders,
  ListMessages,
  ListMyMentionTagSubscriptions,
  ListPinnedMessages,
  ListThreadReplies,
  MarkAsRead,
  PinMessage,
  RemoveConversationMember,
  RemoveReaction,
  ReplyInThread,
  ResolveChatContext,
  SearchMessages,
  SendMessage,
  SendTypingIndicator,
  SubscribeToMentionTag,
  UnpinMessage,
  UnsubscribeFromMentionTag,
  UpdateChatPolicy,
  UpdateConversation,
  UpdateConversationMemberRole,
  UpdatePresence,
};
